import { differenceInDays } from 'date-fns';
import { useRouter } from 'next/router';
import { getIsDemoFarm } from 'utils/general';

import routes from '@/shared/constant/routes';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export const useFreeTrial = () => {
  const { push, pathname } = useRouter();

  const { user } = useAuth();
  const FREE_TRIAL_PERIOD = user?.companyId === 900 ? 21 : 7;

  const [assetsList, setStore] = useStore((store) => store?.assetsList);

  const hasSubscription = !!user?.subscription;

  //  TODO: IMP - bigger than or equal?
  const freeTrialOver = user?.company?.createdAt
    ? differenceInDays(new Date(), new Date(user.company.createdAt)) >=
      FREE_TRIAL_PERIOD
    : false;

  const freeTrialDaysLeft = user?.company
    ? FREE_TRIAL_PERIOD -
      differenceInDays(new Date(), new Date(user?.company?.createdAt))
    : undefined;

  const hasFreeTrial = !hasSubscription && !freeTrialOver;

  const canAccessAssets = hasSubscription || hasFreeTrial;

  const exitDemo = async () => {
    if (pathname !== routes.home && pathname !== routes.billing)
      await push(routes.home);
    setStore({
      asset: assetsList?.farms.find((farm) => !getIsDemoFarm(farm)),
    });
  };

  return {
    hasSubscription,
    freeTrialOver,
    hasFreeTrial,
    canAccessAssets,
    exitDemo,
    freeTrialDaysLeft,
    FREE_TRIAL_PERIOD,
  };
};
